import { Component, OnInit } from "@angular/core";
import { RUsuarioNivelesService } from "../../servicios/r-usuario-niveles.service";
import { CatUsuariosService } from "../../servicios/cat-usuarios.service";
import { CatNivelSeguridadesService } from "../../servicios/cat-nivel-seguridades.service";
import { PrivilegiosService } from "../../servicios/privilegios.service";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { MenuItem, SelectItem } from "primeng/api";
import { ObtenerUsuarioPorCargoInput, RUsuarioNiveles } from "../../entidades/entidades";
import { ObtenerUsuarioPorCargo } from "../../entidades/entidades";
import { CatNivelSeguridades } from "../../entidades/entidades";
import { Privilegios } from "../../entidades/entidades";

import { ObtenerUsuarioPorCargoService } from "../../servicios/obtener-usuario-por-cargo.service";
//import { ConsoleReporter } from "jasmine";

@Component({
  selector: "app-rusuario-niveles-grid",
  templateUrl: "./rusuario-niveles-grid.component.html",
  styleUrls: ["./rusuario-niveles-grid.component.css"],
})
export class RUsuarioNivelesGridComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  catUsuarios: SelectItem[];
  catUsuarioUser: SelectItem[];
  public catUsuariosSelect: ObtenerUsuarioPorCargo;

  catNivelSeguridadesFiltro: SelectItem[];
  catNivelSeguridades: SelectItem[];
  privilegios: SelectItem[];
  public PrivilegiosSelect: Privilegios;
  rUsuarioNiveles: RUsuarioNiveles[];
  itemsMenu: MenuItem[];
  columnasTabla: any[];
  clonedRUsuarioNiveles: { [s: string]: RUsuarioNiveles } = {};
  rUsuarioNivelesCopy: RUsuarioNiveles[];

  constructor(
    private rUsuarioNivelesService: RUsuarioNivelesService,
    private catUsuariosService: CatUsuariosService,
    private catNivelSeguridadesService: CatNivelSeguridadesService,
    private privilegiosService: PrivilegiosService,
    private obtenerUsuarioPorCargoService: ObtenerUsuarioPorCargoService
  ) { }

  ngOnInit(): void {
    this.getAllCatUsuarios();
    this.getAllCatNivelSeguridades();
    this.getAllPrivilegios();
    this.getAllRUsuarioNiveles();

    // ===============================================================
    //Opciones del menu
    // ===============================================================
    // prettier-ignore
    this.itemsMenu = [
      { label: "Guardar", icon: "pi pi-save", command: (event) => { this.guardarGridRUsuarioNiveles(); } },
      { label: "Refrescar", icon: "pi pi-refresh", command: (event) => { this.getAllRUsuarioNiveles(); } },
    ];

    // ===============================================================
    //Opciones de la tabla
    // ===============================================================
    // prettier-ignore
    this.columnasTabla = [
      { field: "operacion", header: "", ordenar: false, styleHeader: "width: 30px;" },
      { field: "idUsuarioUser", header: "Usuario", ordenar: true, styleHeader: "width: 150px;", },
      { field: "idUsuario", header: "Nombre", ordenar: true, styleHeader: "width: 150px;", },
      { field: "idPrivilegio", header: "Privilegio", ordenar: true, styleHeader: "width: 100px;", },
      { field: "idNivelSeguridad", header: "Nivel Seguridad", ordenar: true, styleHeader: "width: 100px;", },
    ];
  }
  //===============================================================
  //Agrega renglon en el grid
  //===============================================================
  // prettier-ignore
  add() {
    let rUsuarioNivelesNew = new RUsuarioNiveles();
    rUsuarioNivelesNew.cambio = true;
    rUsuarioNivelesNew.id = 0;
    this.rUsuarioNiveles.unshift(rUsuarioNivelesNew);
  }

  //===============================================================
  //Funciones de la tabla
  //===============================================================
  // prettier-ignore
  onEditInit(event) {
    let rUsuarioNivelesEdit = event.data;
    rUsuarioNivelesEdit.cambio = true;
    rUsuarioNivelesEdit.baja = false;
  }

  // prettier-ignore
  onEditCancel(event) {
    let rUsuarioNivelesEdit = event.data;
    let index = this.rUsuarioNiveles.findIndex(
      (obj) => obj.id === rUsuarioNivelesEdit.id
    );
    this.rUsuarioNiveles[index] = { ...this.clonedRUsuarioNiveles[rUsuarioNivelesEdit.id] };
  }

  // prettier-ignore
  onDelete(event, index: number) {
    event.cambio = false;
    event.baja = true;
  }

  // prettier-ignore
  async onEditComplete(event) {
    try {
      let rUsuarioNivelesEdit = event.data;

      //Valida si hay cambios
      if (
        rUsuarioNivelesEdit.id === this.clonedRUsuarioNiveles[rUsuarioNivelesEdit.id].id &&
        rUsuarioNivelesEdit.idUsuario === this.clonedRUsuarioNiveles[rUsuarioNivelesEdit.id].idUsuario &&
        rUsuarioNivelesEdit.idNivelSeguridad === this.clonedRUsuarioNiveles[rUsuarioNivelesEdit.id].idNivelSeguridad &&
        rUsuarioNivelesEdit.idPrivilegio === this.clonedRUsuarioNiveles[rUsuarioNivelesEdit.id].idPrivilegio
      ) {
        let index = this.rUsuarioNiveles.findIndex((obj) => obj.id === rUsuarioNivelesEdit.id);
        this.rUsuarioNiveles[index] = { ...this.clonedRUsuarioNiveles[rUsuarioNivelesEdit.id] };
        return;
      }

      //Validaciones
      //throw new Error("No paso las validaciones.");

      rUsuarioNivelesEdit.cambio = true;
      rUsuarioNivelesEdit.baja = false;
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por onEditComplete");
    }
  }
  //===============================================================
  //Interaccion con servicios
  //===============================================================
  // prettier-ignore
  async guardarGridRUsuarioNiveles() {
    try {
      for (let rUsuarioNivelesFor of this.rUsuarioNiveles) {
        if (rUsuarioNivelesFor.baja) {
          await this.deleteRUsuarioNiveles(rUsuarioNivelesFor);
        } else if (rUsuarioNivelesFor.cambio) {
          rUsuarioNivelesFor.cambio = false;
          this.clonedRUsuarioNiveles[rUsuarioNivelesFor.id] = { ...rUsuarioNivelesFor, };
          if (rUsuarioNivelesFor.id === 0) {
            const datoRetorno = await this.addRUsuarioNiveles(rUsuarioNivelesFor);
            rUsuarioNivelesFor.id = datoRetorno.id;
          } else {
            await this.updateRUsuarioNiveles(rUsuarioNivelesFor);
          }
        }
      }

      this.muestraMensaje.notification("Proceso Concluido.", "top", "center");
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por guardarRUsuarioNiveles");
    }
  }

  // prettier-ignore
  async addRUsuarioNiveles(rUsuarioNiveles) {
    try {
      const datoretorno = await this.rUsuarioNivelesService
        .add(rUsuarioNiveles)
        .toPromise();
      return datoretorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por addRUsuarioNiveles");
    }
  }

  // prettier-ignore
  async getAllRUsuarioNiveles() {
    try {
      const datoRetorno = await this.rUsuarioNivelesService.getAll().toPromise();
      this.rUsuarioNiveles = datoRetorno;
      this.rUsuarioNivelesCopy = datoRetorno;


      for (var i = 0, len = this.rUsuarioNiveles.length; i < len; ++i)
        this.clonedRUsuarioNiveles[this.rUsuarioNiveles[i].id] = { ...this.rUsuarioNiveles[i], };
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllRUsuarioNiveles");
    }
  }

  // prettier-ignore
  async updateRUsuarioNiveles(rUsuarioNiveles: RUsuarioNiveles) {
    try {
      const datoRetorno = await this.rUsuarioNivelesService
        .update(rUsuarioNiveles)
        .toPromise();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por updateRUsuarioNiveles");
    }
  }

  // prettier-ignore
  async deleteRUsuarioNiveles(rUsuarioNiveles: RUsuarioNiveles) {
    try {
      const datoRetorno = await this.rUsuarioNivelesService
        .delete(rUsuarioNiveles.id)
        .toPromise();
      this.getAllRUsuarioNiveles();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por deleteRUsuarioNiveles");
    }
  }

  // prettier-ignore
  async getAllCatUsuarios() {
    try {
      let busquedaUsuario = new ObtenerUsuarioPorCargoInput;
      busquedaUsuario.idCargo = null;
      busquedaUsuario.idEstatus = 1;
      const datoRetorno = await this.obtenerUsuarioPorCargoService.getBusquedas(busquedaUsuario).toPromise();
      this.catUsuarios = datoRetorno.map((datos) => {
        return { label: datos.nombre, value: datos.id };
      });

      this.catUsuarioUser= datoRetorno.map((datos) => {
        return { label: datos.nombreUsuario, value: datos.id };
      });
      //this.catUsuarios.unshift({ label: "Todos", value: null });

    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatUsuarios");
    }
  }

  // prettier-ignore
  async getAllCatNivelSeguridades() {
    try {
      const datoRetorno = await this.catNivelSeguridadesService.getAll().toPromise();
      this.catNivelSeguridades = datoRetorno.map((datos) => {
        return { label: datos.descripcion, value: datos.id };
      });
      this.catNivelSeguridadesFiltro = datoRetorno.map((datos) => {
        return { label: datos.descripcion, value: datos.id };
      });
      //this.catNivelSeguridadesFiltro.unshift({ label: "Todos", value: null });
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatNivelSeguridades");
    }
  }

  // prettier-ignore
  async getAllPrivilegios() {
    try {
      const datoRetorno = await this.privilegiosService.getAll().toPromise();
      this.privilegios = datoRetorno.filter(datos => ![12, 16, 56, 54, 3, 9, 15, 68, 45, 13].includes(datos.id))
      .map(datos => ({
        label: datos.descripcion,
        value: datos.id
      }));
      console.log("priv: ", datoRetorno);
      //this.privilegios.unshift({ label: "Todos", value: null });
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getPrivilegios");
    }
  }
  UserSelected(selectedValues: number[], field: string, condition: string): void {
    if (selectedValues.length === 0) 
      // Si no hay valores seleccionados, muestra todos los niveles de usuarios
      this.rUsuarioNiveles = [...this.rUsuarioNivelesCopy];
    else 
      // Filtra los niveles de usuarios basados en los valores seleccionados
      this.rUsuarioNiveles = this.rUsuarioNivelesCopy.filter(user => selectedValues.includes(user.idUsuario));

  }
}